import { deviceIsMobile } from "@/utils/device-utils";
// import createPersistedState from 'vuex-persistedstate';

let vuexPersistedstate;

// 仅在客户端环境中加载 vuex-persistedstate
if (process.client) {
  vuexPersistedstate = require('vuex-persistedstate').default;
}

export const state = () => ({
  userInfo: {},
  lan: 'en', // 默认语言
  isMobile: deviceIsMobile(),
  customPrompt: '',
});

export const getters = {
  getUserInfo(state) {
    return state.userInfo;
  },
  lan(state) {
    return state.lan;
  },
  isMobile(state) {
    return state.isMobile;
  },
};

export const mutations = {
  setUserInfo(state, newValue) {
    state.userInfo = newValue;
  },
  setLan(state, newValue) {
    state.lan = newValue;
  },
  setCustomPrompt(state, prompt) {
    state.customPrompt = prompt;
  }
};

